import { selx } from "clsx";
import { jsx } from "panel";
import { ButtonSize } from "common/components/button/constants";
import { ButtonBarEl } from "common/components/button-bar";
import { Directions } from "common/components/drop-menu/types";
import { InputEl } from "common/components/input";
import { SectionEl } from "common/components/section";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { SwitchEl } from "common/components/switch";
import { Placement } from "common/components/tooltip/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section";
import { CountType } from "common/report/funnels/models/types";
import {
  EntryType,
  RowLabelType,
  SelectorTypeDefinitions
} from "common/query-builder/query-entry-section/types";
import {
  CONVERSION_WINDOW_TOOLTIP,
  EXCLUSION_EVENTS_TOOLTIP,
  FunnelOrder,
  HOLD_PROPERTY_CONSTANT_DISABLED_TOOLTIP,
  HOLD_PROPERTY_CONSTANT_TOOLTIP,
  ORDER_OPTIONS
} from "common/report/funnels/models/constants";
import { PropertyCombineMode } from "common/query-builder/query-block/properties-menu/types";
import { StickyPlaceholderEl } from "common/widgets/sticky-placeholder";
import { ConversionCriteriaAction } from "./types";
import styles from "./index.module.styl";
export function template() {
  var _a, _b, _c, _d, _e, _f;
  const {
    conversionWindowErrorMsg,
    isConversionWindowMenuOpen,
    isConversionWindowMenuHovered,
    isCountTypeMenuOpen,
    isCountTypeMenuHovered,
    selectedValue
  } = this.state;
  const ConversionWindowMenu = ({
    conversionWindowErrorMsg: conversionWindowErrorMsg2,
    isConversionWindowMenuOpen: isConversionWindowMenuOpen2,
    isConversionWindowMenuHovered: isConversionWindowMenuHovered2,
    selectedValue: selectedValue2,
    selectedLabelPrefix = ``
  }) => /* @__PURE__ */ jsx(SelectEl, {
    sel: selx(styles.conversionWindowSelect),
    attrs: {
      elref: `conversionWindowSelect`,
      "always-show-caret": this.attr(`selected`).countType !== CountType.Session && (isConversionWindowMenuHovered2 || isConversionWindowMenuOpen2),
      disabled: this.isConversionWindowDisabled(),
      theme: SelectTheme.Tertiary,
      open: isConversionWindowMenuOpen2,
      "selected-option": `${selectedLabelPrefix}${this.helpers.getConversionWindowLabel()}`,
      tooltip: { ...CONVERSION_WINDOW_TOOLTIP, placement: Placement.Right },
      icon: { leftIcon: `stop-watch`, rightIcon: `double-caret` }
    },
    on: {
      menuChange: this.handleConversionWindowMenuChange,
      mouseenter: this.handleConversionWindowMenuMouseEnter,
      mouseleave: this.handleConversionWindowMenuMouseLeave
    }
  }, /* @__PURE__ */ jsx("div", {
    attrs: { slot: `body` }
  }, isConversionWindowMenuOpen2 ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: selx(styles.conversionWindowMenu)
  }, /* @__PURE__ */ jsx("h4", {
    sel: selx(styles.conversionWindowMenuTitle)
  }, "Conversion Window"), /* @__PURE__ */ jsx("p", {
    sel: selx(styles.conversionWindowMenuDescription)
  }, "The window of time a user has to complete all steps once they enter the funnel."), /* @__PURE__ */ jsx(InputEl, {
    sel: selx(styles.conversionWindowValueInput),
    attrs: {
      type: `number`,
      size: `medium`,
      "validation-status": conversionWindowErrorMsg2 ? `invalid` : ``,
      "error-message": conversionWindowErrorMsg2
    },
    class: { error: !!conversionWindowErrorMsg2 },
    on: {
      change: (ev) => ev.stopPropagation(),
      input: this.helpers.changeConversionWindowValue,
      keyup: this.helpers.onKeyStroke
    },
    hook: { insert: this.helpers.inputInserted },
    props: { value: selectedValue2 }
  }), /* @__PURE__ */ jsx(SelectEl, {
    sel: selx(styles.conversionWindowUnitSelector),
    attrs: {
      sections: this.helpers.getConversionWindowSections()
    },
    on: { change: this.helpers.changeConversionWindowUnit }
  })), /* @__PURE__ */ jsx(ButtonBarEl, {
    sel: selx(`mp-button-bar-primary`),
    attrs: {
      disabled: !!conversionWindowErrorMsg2,
      tabindex: 0
    },
    on: { click: this.helpers.applyConversionWindowSelections }
  }, "Apply")) : null));
  const builderParams = this.attr(`builder-params`);
  const isSticky = this.attr(`enable-sticky-header`);
  return /* @__PURE__ */ jsx("div", {
    sel: selx(styles.conversionQueryOptionsWrapper)
  }, isSticky && /* @__PURE__ */ jsx(StickyPlaceholderEl, {
    sel: selx(styles.stickyPlaceholder),
    props: {
      stickyElm: this.getStickyHeaderElm()
    }
  }), /* @__PURE__ */ jsx("div", {
    class: {
      [styles.isSticky]: isSticky
    },
    sel: selx(styles.converstionCriteriaHeader),
    hook: {
      insert: (vnode) => isSticky && this.handleInsertStickyHeader(vnode.elm)
    }
  }, /* @__PURE__ */ jsx(SectionEl, {
    sel: selx(styles.section),
    attrs: {
      "header-title": `Conversion Criteria`,
      "non-collapsible": true
    }
  }, /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      slot: `actions`,
      theme: SelectTheme.Tertiary,
      "always-show-caret": true,
      "selected-option": `Advanced`,
      "menu-alignment": Directions.Right,
      "menu-width": 245,
      size: ButtonSize.Small,
      tooltip: { placement: Placement.Right },
      "experimental-positioning": true
    },
    on: {
      change: (ev) => this.handleConversionCriteriaAction(ev)
    },
    props: {
      sections: [
        {
          items: [
            ...!this.attr(`hide-any-order`) ? [
              {
                label: `Any Order`,
                icon: `top-paths`,
                tooltip: ORDER_OPTIONS.find((order) => this.attr(`selected`).funnelOrder === order.value).tooltip,
                actionsRenderer: () => SwitchEl({
                  attrs: {
                    on: this.attr(`selected`).funnelOrder === FunnelOrder.Any
                  },
                  on: {
                    change: ({ detail: { on } }) => this.changeOptions({ funnelOrder: on ? FunnelOrder.Any : FunnelOrder.Loose })
                  }
                })
              }
            ] : [],
            {
              icon: `eye-hide`,
              label: `Exclude users who did...`,
              value: ConversionCriteriaAction.ExcludeEvent,
              tooltip: EXCLUSION_EVENTS_TOOLTIP
            },
            {
              icon: `lock`,
              label: `Holding property constant...`,
              value: ConversionCriteriaAction.HoldProperty,
              tooltip: this.holdingPropertyConstantLimitReached ? HOLD_PROPERTY_CONSTANT_DISABLED_TOOLTIP : HOLD_PROPERTY_CONSTANT_TOOLTIP,
              isDisabled: this.holdingPropertyConstantLimitReached
            }
          ]
        }
      ]
    }
  }))), /* @__PURE__ */ jsx(SectionEl, {
    sel: selx(styles.section),
    attrs: {
      "non-collapsible": true,
      "is-closed": this.attr(`hide-conversion-window`)
    }
  }, /* @__PURE__ */ jsx(ConversionWindowMenu, {
    conversionWindowErrorMsg,
    isConversionWindowMenuOpen,
    isConversionWindowMenuHovered,
    selectedValue,
    selectedLabelPrefix: `Within `
  })), /* @__PURE__ */ jsx(SectionEl, {
    sel: selx(styles.section),
    attrs: {
      "non-collapsible": true
    }
  }, !this.attr(`hide-count-selector`) && /* @__PURE__ */ jsx(SelectEl, {
    sel: selx(styles.conversionQueryOptionsCountType),
    attrs: {
      elref: `countTypeSelect`,
      "always-show-caret": isCountTypeMenuHovered || isCountTypeMenuOpen,
      "menu-width": 100,
      "tab-index": 0,
      open: isCountTypeMenuOpen,
      sections: this.helpers.getCountTypeSections(),
      theme: SelectTheme.Tertiary,
      icon: { leftIcon: `column-select`, rightIcon: `double-caret` },
      tooltip: { placement: Placement.Right }
    },
    on: {
      menuChange: this.handleCountTypeMenuChange,
      change: this.helpers.changeCountType,
      mouseenter: this.handleCountTypeMenuMouseEnter,
      mouseleave: this.handleCountTypeMenuMouseLeave
    }
  })), /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    sel: selx(styles.queryEntrySection, { [styles.isEmpty]: ((_a = builderParams.exclusionSteps) == null ? void 0 : _a.length) === 0 }),
    attrs: {
      "data-group-id": builderParams.dataGroupId,
      "data-groups-enabled": builderParams.dataGroupsEnabled,
      "project-has-people": builderParams.projectHasPeople,
      "project-has-cohorts": builderParams.projectHasCohorts,
      "project-id": builderParams.projectId,
      "workspace-id": builderParams.workspaceId,
      "track-name": builderParams.trackName,
      "project-as-of-date": builderParams.projectAsOfDate,
      entries: (_c = (_b = builderParams.exclusionSteps) == null ? void 0 : _b.map((step) => ({ ...step, prefixLabel: `Exclude ` }))) != null ? _c : [],
      "row-draggable": true,
      "row-label-type": RowLabelType.None,
      "entry-type": EntryType.ExclusionEvent,
      "include-custom-properties": `all`,
      "disable-add-entry": true,
      "num-exclusion-steps": (_d = builderParams.entries) == null ? void 0 : _d.length,
      "row-label-type-for-exclusion-steps": builderParams.entryRowLabelType,
      "track-properties": { sectionName: `exclusion-steps` }
    },
    on: {
      update: (ev) => this.handleExclusionEventsUpdate(ev)
    },
    hook: {
      insert: (vnode) => this.setElRef(`exclusionSteps`, vnode.elm)
    }
  }), /* @__PURE__ */ jsx(QueryEntrySectionEl, {
    sel: selx(styles.queryEntrySection, { [styles.isEmpty]: ((_e = builderParams.exclusionSteps) == null ? void 0 : _e.length) === 0 }),
    attrs: {
      "project-id": builderParams.projectId,
      "workspace-id": builderParams.workspaceId,
      "track-name": builderParams.trackName,
      "row-limit": this.attr(`max-holding-property-constant`),
      "row-draggable": true,
      "row-label-type": RowLabelType.None,
      "include-custom-properties": `all`,
      "disable-add-entry": true,
      "disable-map-to-lookup-table": true,
      "event-names": this.attr(`event-names`),
      "property-combine-mode": PropertyCombineMode.Intersection,
      "row-types": [SelectorTypeDefinitions.Segment],
      "track-properties": { "for hold property constant": true, sectionName: `hold-prop-constant` },
      entries: (_f = this.attr(`selected`)) == null ? void 0 : _f.holdingPropertyConstant.map((prop) => ({
        type: SelectorTypeDefinitions.Segment,
        event: prop,
        filters: [],
        prefixLabel: `Hold constant `
      }))
    },
    on: {
      update: (ev) => this.handlePropertyConstantUpdate(ev)
    },
    hook: {
      insert: (vnode) => this.setElRef(`holdProps`, vnode.elm)
    }
  }));
}
